/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/components/ingresocausa/datos-ingreso.component';
import * as i4 from '../../../../../src/app/services/usuario.service';
import * as i5 from '../../../../../src/app/services/expediente.service';
import * as i6 from '../../../../../src/app/services/common.service';
var styles_DatosIngresoComponent = [];
export var RenderType_DatosIngresoComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_DatosIngresoComponent, data: {} });
function View_DatosIngresoComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'horizontal-collapse'], ['style', 'margin-top:20px;']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'well']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                ', '\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-secondary']], [[8, 'hidden', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickOK() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Continuar'])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.MsgTipos;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.verAceptar;
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_DatosIngresoComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = ((((_v.context.$implicit.orgId + '|') + _v.context.$implicit.depId) + '|') + _v.context.$implicit.sedDepId);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = ((((_v.context.$implicit.orgId + '|') + _v.context.$implicit.depId) + '|') + _v.context.$implicit.sedDepId);
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descripcion;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_DatosIngresoComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class',
                'col-xs-12 col-sm-10']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'select']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 9, 'select', [['class', 'form-control reset-margin'],
            ['name', 'orgCombo']], [[8, 'disabled', 0]], [[null, 'focus'], [null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('focus' === en)) {
                var pd_0 = (_co.hideErrorMsg() !== false);
                ad = (pd_0 && ad);
            }
            if (('change' === en)) {
                var pd_1 = (_co.onChangeSelectOrg($event.target.value) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        (_l()(), i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosIngresoComponent_3)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = '0';
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = '0';
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = _co.orgList;
        _ck(_v, 12, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.ingreso;
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_DatosIngresoComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class',
                'col-xs-12 col-sm-10']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(),
            i0.ɵeld(0, [['input', 1]], null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
                ['disabled', ''], ['placeholder', ''], ['type', 'text']], [[2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'input'], [null,
                    'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                if (('input' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 3)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (i0.ɵnov(_v, 3).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (i0.ɵnov(_v, 3)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (i0.ɵnov(_v, 3)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('input' === en)) {
                    var pd_4 = ((i0.ɵnov(_v, 2).value = $event.target.value.toUpperCase()) !== false);
                    ad = (pd_4 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null),
        i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0,
                'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = '';
        var currVal_8 = ((_co.expConexo == null) ? null : _co.expConexo.organismo);
        _ck(_v, 5, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 7).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 7).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 7).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 7).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 7).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 7).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
export function View_DatosIngresoComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 77, 'div', [['class',
                'panel-body height-panel-nuevacausa']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [['class', 'wizard-title']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Datos del Ingreso'])), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosIngresoComponent_1)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n'])),
        (_l()(), i0.ɵted(null, [' '])), (_l()(), i0.ɵted(null, ['\n'])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-7 col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [['class', 'ts-label reset-margin alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Ingreso Directo'])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col-xs-5 col-sm-2 padBottom2 reset-margin alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 10, 'label', [['class', 'switch']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['type', 'checkbox']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 27).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.CheckboxControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.CheckboxControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 0, 'span', [['class', 'slider round']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 13, 'div', [['class', 'fg-line margin-bottom-obs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Organismo'])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosIngresoComponent_2)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosIngresoComponent_4)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 17, 'div', [['class', 'fg-line margin-bottom-obs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Secretaria'])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-xs-12 col-sm-10']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, [['input', 1]], null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['disabled', ''], ['placeholder', ''], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 69)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 69).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 69)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 69)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = ((i0.ɵnov(_v, 68).value = $event.target.value.toUpperCase()) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0,
                'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.visibleMsg;
        _ck(_v, 6, 0, currVal_0);
        var currVal_8 = _co.ingDirecto;
        var currVal_9 = _co.ingreso;
        _ck(_v, 29, 0, currVal_8, currVal_9);
        var currVal_10 = _co.comboOrg;
        _ck(_v, 49, 0, currVal_10);
        var currVal_11 = !_co.comboOrg;
        _ck(_v, 52, 0, currVal_11);
        var currVal_19 = '';
        var currVal_20 = ((_co.secretaria == null) ? null : _co.secretaria.descripcion);
        _ck(_v, 71, 0, currVal_19, currVal_20);
    }, function (_ck, _v) {
        var currVal_1 = i0.ɵnov(_v, 31).ngClassUntouched;
        var currVal_2 = i0.ɵnov(_v, 31).ngClassTouched;
        var currVal_3 = i0.ɵnov(_v, 31).ngClassPristine;
        var currVal_4 = i0.ɵnov(_v, 31).ngClassDirty;
        var currVal_5 = i0.ɵnov(_v, 31).ngClassValid;
        var currVal_6 = i0.ɵnov(_v, 31).ngClassInvalid;
        var currVal_7 = i0.ɵnov(_v, 31).ngClassPending;
        _ck(_v, 26, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_12 = i0.ɵnov(_v, 73).ngClassUntouched;
        var currVal_13 = i0.ɵnov(_v, 73).ngClassTouched;
        var currVal_14 = i0.ɵnov(_v, 73).ngClassPristine;
        var currVal_15 = i0.ɵnov(_v, 73).ngClassDirty;
        var currVal_16 = i0.ɵnov(_v, 73).ngClassValid;
        var currVal_17 = i0.ɵnov(_v, 73).ngClassInvalid;
        var currVal_18 = i0.ɵnov(_v, 73).ngClassPending;
        _ck(_v, 68, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
    });
}
export function View_DatosIngresoComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'datos-ingreso', [], null, null, null, View_DatosIngresoComponent_0, RenderType_DatosIngresoComponent)), i0.ɵdid(114688, null, 0, i3.DatosIngresoComponent, [i4.UsuarioService, i5.ExpedienteService, i6.CommonService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var DatosIngresoComponentNgFactory = i0.ɵccf('datos-ingreso', i3.DatosIngresoComponent, View_DatosIngresoComponent_Host_0, { instancia: 'instancia',
    cir: 'cir', fue: 'fue', tex: 'tex', ingDirecto: 'ingDirecto' }, { onComplete: 'onComplete' }, []);
//# sourceMappingURL=datos-ingreso.component.ngfactory.js.map